/**
 * @generated SignedSource<<09e2053a92fe08bf43e5fd17c3465d4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapClusterizedPointMarkers_map",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markersMaxClusterRadius",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MapElementPoint",
      "kind": "LinkedField",
      "name": "clusterizedPoints",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapClusterizedPointMarker_point"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMapElementsFilteredIn_map"
    }
  ],
  "type": "Map",
  "abstractKey": "__isMap"
};

node.hash = "eec52aa490da54bf3e3b070933e70668";

module.exports = node;
